import authService from 'ApiService/Auth/AuthService';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import Centered from 'layouts/auth/types/Centered';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const OrgForgotPassword = () => {
  const [email, setEmail] = useState('');
  const router = useNavigate();

  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (email) {
      try {
        const response = await authService.forgetPassword(email);
        if (response.data.success) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        // toast.error("Something went wrong. Please try again later.");
        if (error.response.status === 429) {
          toast.error('Too many requests from this IP, please try again later');
        } else {
          toast.error('Something went wrong. Please try again later.');
        }
      }
    } else {
      toast.error('Please enter your email.');
    }
  };

  return (
    <Centered
      bgImage="linear-gradient(135deg, #868CFF 100%, #4318FF 10%)"
      maincard={
        <Card extra="max-w-[405px] md:max-w-[510px] md:w-[510px] h-max mx-2.5 md:mx-auto mt-[50px] mb-auto py-2.5 px-4 md:!p-[50px] pt-8 md:pt-[50px]">
          <h3 className="mb-[10px] text-4xl font-bold text-gray-900 dark:text-white">
            Forgot Password
          </h3>
          <p className="mb-9 ml-1 text-base text-gray-600">
            Enter your email to reset the password
          </p>
          <form onSubmit={handleSubmit}>
            <InputField
              variant="auth"
              extra="mb-3"
              label="Email*"
              placeholder="mail@simple.com"
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={handleChange}
            />
            <button
              type="submit"
              className="mt-4 w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
            >
              Send Code
            </button>
          </form>
          <div className="mt-3">
            <span className="text-sm font-medium text-navy-700 dark:text-gray-500">
              Not registered yet?
            </span>
            <a
              href="/register"
              className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-500 dark:text-white"
            >
              Create an Account
            </a>
          </div>
        </Card>
      }
    />
  );
};

export default OrgForgotPassword;
